module.exports = __webpack_public_path__ + "static/media/Signin.b5554327.jpg";